import * as React from 'react';
import { Device } from '@ixicare/resources';
import { FieldValues } from '../components/DeviceConfigForm/schema';

/**
 * What the device's resident contributes to its configuration, as the layer between the site's
 * settings and the device's own.
 *
 * Parameters, not the resident's own wording: the service derives them for this device's type, so
 * they can be matched against the form's fields. Keyed on the device for that reason -- the same
 * settings mean different parameters on different devices.
 *
 * `undefined` until it is known, so a form seeded before the fetch lands flags nothing rather than
 * flagging everything. A device with no resident, or a resident who sets nothing, is an empty
 * object: nothing to compare against, which is not the same as an error.
 *
 * Failures are swallowed, as for the site layer: this drives an annotation, not the form's
 * contents, and a device must stay editable when the layer cannot be read.
 */
export const useOwnerLayerValues = (deviceUuid?: string | null): FieldValues | undefined => {
  const [values, setValues] = React.useState<FieldValues>();

  React.useEffect(() => {
    if (!deviceUuid) return;
    let cancelled = false;
    Device.getDeviceOwnerSettings(deviceUuid)
      .then((response) => {
        if (!cancelled) setValues(response.owner_parameters ?? {});
      })
      .catch(() => {
        if (!cancelled) setValues(undefined);
      });
    return () => {
      cancelled = true;
    };
  }, [deviceUuid]);

  return values;
};
